import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function useAuth(setIsAuthenticated) {
    const navigate = useNavigate();

    useEffect(() => {
        const checkExpiration = () => {
            const token = localStorage.getItem('token');
            const tokenExpiration = localStorage.getItem('expiryTime');

            if (!token || !tokenExpiration || new Date().getTime() > tokenExpiration) {
                localStorage.removeItem('token');
                localStorage.removeItem('expiryTime');
                setIsAuthenticated(false);
                navigate('/');
            }
        };

        checkExpiration(); // Check once on mount

        const intervalId = setInterval(checkExpiration, 60 * 1000); // Check every minute

        return () => clearInterval(intervalId);
    }, [navigate, setIsAuthenticated]);

    useEffect(() => {
        const handleStorageChange = () => {
            const token = localStorage.getItem('token');
            if (!token) {
                setIsAuthenticated(false);
                alert("Session Expire")
                navigate('/');
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [navigate, setIsAuthenticated]);
}
